import type { AxiosRequestConfig } from 'axios';

import { axiosInstance } from '../axios-instance';

type RequestOptions = AxiosRequestConfig | undefined;

/**
 * Omitted from published OpenAPI until BE documents PUT `/features/sensitivity` (TROC-243).
 * Symbol naming follows Orval's V1 convention so the regenerated client can replace this file.
 */
export const putApiUserManagementV1FeaturesSensitivity = (updateFeatureSensitivityInput: unknown, options?: RequestOptions, signal?: AbortSignal) => {
  return axiosInstance<unknown>(
    {
      url: '/api/user-management/v1/features/sensitivity',
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateFeatureSensitivityInput,
      signal
    },
    options
  );
};
